module.exports = __webpack_public_path__ + "img/szsjjx.4ea400cf.png";